/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Pkl_Note_Create_PlhInputs */

const vi_pkl_note_create_plh = /** @type {(inputs: Pkl_Note_Create_PlhInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tạo phiếu lấy hàng`)
};

/**

* @param {Pkl_Note_Create_PlhInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const pkl_note_create_plh = /** @type {((inputs?: Pkl_Note_Create_PlhInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Pkl_Note_Create_PlhInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_pkl_note_create_plh(inputs)
});